import React from "react";
import { Modal } from "react-bootstrap";
import { Carousel } from "react-bootstrap";
import Button from "../../../components/button";

const BannerPreview = ({ preview, closePreviewModal, bannerImages }) => {
  return (
    <Modal show={preview} onHide={closePreviewModal} centered>
      <style>
        {`
            .carousel-control-prev-icon, .carousel-control-next-icon {
                background-color: black;
                background-size: 100%;
            }
        `}
      </style>
      <Modal.Header closeButton>
        <Modal.Title>Banner Preview</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        <Carousel>
          {bannerImages?.map((img, index) => (
            <Carousel.Item key={index}>
              <img
                src={img}
                alt={`Carousel Image ${index + 1}`}
                style={{
                  height: "19rem",
                  display: "flex",
                  justifySelf: "center",
                }}
              />
            </Carousel.Item>
          ))}
        </Carousel>
      </Modal.Body>
      <Modal.Footer>
        <Button text="Close" callBack={closePreviewModal} />
      </Modal.Footer>
    </Modal>
  );
};

export default BannerPreview;
